module.exports = __webpack_public_path__ + "02_mustache_grey.8b297c48.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer3/02_mustache_grey.png
// module id = 23aY
// module chunks = 0